<template>
	<div class="myDocTiles">
		<div v-if="!isEmpty" class="tileWrap">
			<div v-for="document in notarizationDocuments" :key="document.id" :class="['itemTile', { 'done': document.status !== 'uploading' }, { 'cancelled': document.status === `cancelled` }]">
				<div class="icon">
					<div class="documentIcon icon-pdf" />
				</div>
				<div class="fileInfo">
					<span class="name">{{ document.fileName }}</span>
					<span v-if="!document.message" class="status"><span class="statusIcon" />Uploaded</span>
					<span v-else class="status"><span class="statusIcon" />{{ document.message }}</span>
				</div>
				<dropdown-menu v-slot="{hide}">
					<li><a class="download" @click="hide();download(document)"><span>Download</span></a></li>
					<li><a class="delete" @click="hide();removeDocument(document)"><span>Delete</span></a></li>
				</dropdown-menu>
			</div>
			<remove-dialog />
		</div>
		<upload-manager />
		<add-document />
	</div>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import API from "@ado/notarization-vue-common/src/API/API.js";
import DropdownMenu from "../../components/ui/DropdownMenu.vue";
import { useSlateMessage } from "@ado/notarization-vue-common/src/composables/slateMessage.js";
import RemoveDialog from "./RemoveDialog.vue";
import { isUserSignedIn } from "../../helpers/signin";
import AddDocument from "./AddDocument.vue";
import UploadManager from "./UploadManager.vue";
import { ItemTileFade } from "../../mixins/ItemTileFade";

const DataServiceAPI = new API(
	`${window.location.origin}/api/foundation/file-storage/v1`
);

async function getDownloadUrl(document) {
	return DataServiceAPI.GET(`/file-links/${document.workingFileId}`);
}

export default {
	components: {
		DropdownMenu,
		RemoveDialog,
		AddDocument,
		UploadManager,
	},
	mixins: [new ItemTileFade()],
	setup() {
		const { showLoadingMessage, hideLoadingMessage } = useSlateMessage();

		return {
			showLoadingMessage,
			hideLoadingMessage
		};
	},
	computed: {
		isSignedIn() {
			return isUserSignedIn();
		},
		...mapState([`notarizationDocuments`, `uploadStatusEnum`, `uploadFileInputId`]),
		...mapGetters([`isEmpty`]),
	},
	mounted() {
		this.showLoadingMessage();
		this.hideLoadingMessage();
	},
	methods: {
		openShowExistingDialog() {
			this.showExistingDialog(true);
		},
		uploadLink() {
			document.getElementById(this.uploadFileInputId).click();
		},
		download(doc) {
			getDownloadUrl(doc).then((response) => {
				let link = window.document.createElement(`a`);
				link.download = doc.fileName;
				link.href = response.result;
				window.document.body.appendChild(link);
				link.click();
				window.document.body.removeChild(link);
			});
		},
		removeDocument(document) {
			this.documentToRemove(document);
			this.showRemoveDialog(true);
		},
		...mapMutations([
			`showExistingDialog`,
			`openSignInDialog`,
			`documentToRemove`,
			`showRemoveDialog`,
		]),
	},
};
</script>